import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'framework7-react';
import II18 from '../../translate/II18';

const AUTO_CLOSE_MS = 3000;

/**
 * Success footer: Fertig + auto-close after 3s (mobile and desktop).
 */
export default function QesSuccessFooter({
  onDone,
  autoCloseMs = AUTO_CLOSE_MS
}) {
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useEffect(() => {
    const t = setTimeout(() => {
      onDoneRef.current?.();
    }, autoCloseMs);
    return () => clearTimeout(t);
  }, [autoCloseMs]);

  return (
    <div
      id="qes_success_footer"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 24,
        gap: 8
      }}
    >
      <Button
        id="qes_success_done"
        raised
        fill
        style={{ minWidth: 150 }}
        onClick={() => onDoneRef.current?.()}
      >
        <II18>title_done</II18>
      </Button>
      <span style={{ color: '#999', fontSize: 13 }}>
        <II18>qes_step_auto_close_hint</II18>
      </span>
    </div>
  );
}

QesSuccessFooter.propTypes = {
  onDone: PropTypes.func,
  autoCloseMs: PropTypes.number
};
